var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tripadvisorRating)?_c('div',[_c('v-divider',{staticClass:"mt-3 mb-2"}),_vm._v(" "),_c('tripadvisor-rating',{attrs:{"tripadvisor-rating":_vm.tripadvisorRating}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }